angular.module('unica_workshop.workshop_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// WORKSHOP
		.state('app.workshop', {
			url: '/workshop',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/workshop/templates/workshop.html',
					controller: 'WorkshopBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

		// WORKSHOP LIST
		.state('app.workshop.list', {
			url: '/list/:event_id',
			views: {
				'workshopContent': {
					templateUrl: './modules/workshop/templates/list.html',
					controller: 'WorkshopListController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Workshop',
				parent: function($scope) {
					return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + '})';
				}
			}
		})

		// WORKSHOP CREATE
		.state('app.workshop.create', {
			url: '/create/:event_id',
			views: {
				'workshopContent': {
					templateUrl: './modules/workshop/templates/create.html',
					controller: 'WorkshopCreateController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Crea Workshop',
				parent: 'app.workshop.list'
			}
		})

		// WORKSHOP EDIT
		.state('app.workshop.edit', {
			url: '/edit/:event_id/:id',
			views: {
				'workshopContent': {
					templateUrl: './modules/workshop/templates/edit.html',
					controller: 'WorkshopEditController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Modifica Workshop',
				parent: 'app.workshop.list'
			}
		})

		// WORKSHOP registered
		.state('app.workshop.registered', {
			url: '/registered/:event_id/:id',
			views: {
				'workshopContent': {
					templateUrl: './modules/workshop/templates/registered.html',
					controller: 'WorkshopRegisteredController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Lista Registrazioni Workshop',
				parent: 'app.workshop.list'
			}
		});


});

